import { ApiError } from '~/api/errors';

/**
 * Extract a user-friendly error message from an API error.
 * Falls back to the provided default message if the error is not an ApiError.
 */
export function extractApiError(err: unknown, fallback: string): string {
  if (err instanceof ApiError) {
    return err.message;
  }
  if (err instanceof Error) {
    return err.message;
  }
  return fallback;
}

/**
 * The server's support reference for a failed request, when the route sent one
 * (`details.reference`, e.g. the delivery read endpoints' 500). Undefined for
 * any other error so callers can render the line conditionally.
 */
export function extractApiReference(err: unknown): string | undefined {
  return err instanceof ApiError ? err.reference : undefined;
}
